import styled from 'styled-components'

import { spaces } from '@/config/global-parameters'

import HeaderWarn from '../HeaderWarn'
import ProgressEpigraph from './ProgressEpigraph'
import SelectTitle, { ITitleOption, Title } from './SelectTitle'

interface IMainTitle {
  className?: string
  updatedAt: Date // isoFormat
  options?: ITitleOption[]
  onSelect?: (value: string) => void
  topWarn?: string
  bottomWarn?: string
}

const MainTitle = ({
  bottomWarn,
  className,
  onSelect,
  options,
  topWarn,
  updatedAt,
}: IMainTitle) => {
  const territorySelected = (value: string) => {
    if (onSelect) onSelect(value)
  }
  return (
    <Wrapper className={className}>
      <ProgressEpigraph updatedAt={updatedAt} />
      {topWarn && <HeaderWarn>{topWarn}</HeaderWarn>}
      {options
        ? (
          <SelectTitle
            instanceId="consejeros"
            onChange={(option) => option && territorySelected(option?.value)}
            options={options}
          />
        )
        : (
          <Title>Consejo Constitucional</Title>
        )}
      {bottomWarn && <HeaderWarn>{bottomWarn}</HeaderWarn>}
    </Wrapper>
  )
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spaces.s};
  @media (max-width: ${spaces.tabletBreakpoint}) {
    gap: ${spaces.xs};
  }
`

export default MainTitle
